export default function styles(theme) {
  return {
    title: {
      fontFamily: "philosopher",
      fontWeight: "bold",
      fontSize: "5rem",
      textTransform: "uppercase",
      letterSpacing: "5px",
      "-webkit-text-fill-color": "transparent",
      " -webkit-text-stroke": " .1px #B6CFFF"
    },
    num: {
      fontSize: "4rem",
      transition: "all 0.5s ease-in-out !important",
    },

    card: {
      position: "relative",
      height: "max-content",
      backgroundColor: "transparent",
    },
    media: {
      borderRadius: 12,
      border: "1px solid rgba(121, 131, 150, 0.15)",
      height: "22rem",
      width:"100%",
      background: "rgb(142,162,199,0.1)",
      [theme.breakpoints.down("sm")]: {
        height: "15rem",
      },
    },
    cardNum: {
      position: "absolute",
      fontWeight: "bold",
      top: -60,
      left: 20,
      fontSize: "5.8rem",
      fontFamily: "philosopher",
      letterSpacing: "2px",
      margin: "0rem",
      "-webkit-text-fill-color":
        "transparent" /*Will override color (regardless of order) */,
      " -webkit-text-stroke": " 1.5px #63718A",
      transition: "all 0.3s ease-in-out",
      [theme.breakpoints.down("sm")]: {
        fontSize:  "4.5rem",
        top: -45,
        left: 8
      },
    },
    cardNumSolid: { 
      position: "absolute",
      fontWeight: "bold",
      top: -60,
      left: 20,
      fontSize: "5.8rem",
      fontFamily: "philosopher",
      letterSpacing: "2px",
      margin: "0rem",
      "-webkit-text-fill-color": "#63718A", /*Will override color (regardless of order) */
      " -webkit-text-stroke": " 1.5px #63718A",
      [theme.breakpoints.down("sm")]: {
        fontSize:  "4.5rem",
        top: -45,
        left: 8
      },
    },
    cardLink: {
      position: "relative",
      width: "100%",
      maxWidth: "47%",
      marginTop: 80,
      [theme.breakpoints.down("sm")]: {
        maxWidth: "unset"
      }
    },
    cardWrapper: {
      height: "max-content",
      // marginBottom: '10rem',
      position: "relative",
      [theme.breakpoints.down("sm")]: {
        margin: "20px auto"
      }
    },
    alignedCard: {
      alignSelf: "center"
    },

    tagName: {
      color: theme.palette.text.tertiary,
    },
    imageOverlay:{
      position: "absolute",
      borderRadius: 8,
      height: "100%",
      width: "100%",
      opacity: 0.2,
      transition: ".5s ease",
      backgroundColor: "#5D5FEF",
      "&:hover":{
        opacity: 0,
      },
    },
  };
}
